
let resets = [];

function setupWrapper(wrapper) {
  const button = wrapper.querySelector('.sponsoring-button')
  const popup = wrapper.querySelector('.sponsoring-popup');
  const copyBtn = wrapper.querySelector('.sponsoring-popup-copy-button');
  const closeBtn = wrapper.querySelector('.sponsoring-popup-close-button');

  function copyPipeId() {
    const pipeIdEl = popup.querySelector('code')

    if (pipeIdEl === null) {
      return;
    }

    const pipeId = pipeIdEl.innerHTML.trim();

    navigator.clipboard.writeText(pipeId).then(() => {
      if (copyBtn !== null) {
        const oldContent = copyBtn.innerHTML;
        copyBtn.innerHTML = '✅';

        setTimeout(() => {
          if (copyBtn !== null) {
            copyBtn.innerHTML = oldContent;
          }
        }, 2000)
      }
    });
  }

  function openPopup() {
    popup.style.visibility = 'visible';
  }

  function closePopup() {
    popup.style.visibility = 'hidden';
  }

  copyBtn.addEventListener('click', copyPipeId)
  closeBtn.addEventListener('click', closePopup)
  button.addEventListener('click', openPopup)

  return () => {
    copyBtn.removeEventListener('click', copyPipeId)
    closeBtn.removeEventListener('click', closePopup)
    button.removeEventListener('click', openPopup)
  }
}

export function setupSponsoringButtons() {
  resets.forEach(reset => reset());

  resets = Array.from(document.querySelectorAll('.sponsoring-button-wrapper'))
    .map(setupWrapper);
}